// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BzBst","appIcon":"styles_appIcon__cOE_c","title":"styles_title__YkprZ","appIconsContainer":"styles_appIconsContainer__GEDXe"};